export const DROPDOWN_PLACEHOLDER: string = 'placeholder';
